import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaSearchPlus } from "react-icons/fa";
import { FaEdit } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import ApiConfig from "../../../api/ApiConfig";
import { Filter } from "react-feather";
import Params from "../../../config/Params";
import { simplePostCall } from "../../../api/ApiServices";
import LoadingModal from "./Loadingmodal";
import SyllabusTable from "./syllabusTableSkel";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";

export const SyllabusCreate = () => {
  const [curricu, setCurricu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const { t } = useTranslation();

  const Cirriculam = () => {
    let RequestBody = JSON.stringify({
      api_key: Params.api_key,
      customer_id: Params.customer_id,
      user_id: Params.teacher_id,
      page_limit: "100",
      search: search
    });
    simplePostCall(ApiConfig.CURRICULUM_LIST_API, RequestBody)
      .then((data) => {
        console.log(data, "data lists");
        if (data.result) {
          let curriculam = [];
          if (data?.curriculum_list.length > 0) {
            setLoading(false);
            data.curriculum_list.map((ciriculum, index) => {
              console.log(ciriculum, "ciriculum");
              curriculam.push({
                lab: ciriculum.curriculum_name,
                valu: ciriculum.curriculum_id,
                language: ciriculum.curriculum_language,
              });
            });
          }
          setCurricu({ ...curricu, curriculam: curriculam });
          console.log(curricu, "datalatest");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("api res fail", err);
      });
  };

  useEffect(() => {
    Cirriculam();
  }, [search]);
  const navi = useNavigate();
  return (
    <div className="SyllabusCreate">
      {loading ? (
        <SyllabusTable />
      ) : (
        <div className="main-sectionn">
          <div className="row">
            <div className="col-md-12">
              <div className="announcementCreatee">
                <label className="labelCreate">{t("Curriculum")} </label>
                <Link to={"/CreateSyllabus"}>
                  <div className="createButt">
                    <div className="CreateB">{t("Create Curriculum")}</div>
                  </div>
                </Link>
              </div>
            </div>
            <div className="tableCreate">
              <table class="table table-dark table-borderless newTable ">
                <thead className="tableHead">
                  <th>Sr.No</th>
                  <th>{t("Curriculum Name")}</th>
                  <th></th>
                </thead>
                {console.log(curricu.curriculam, "sdfbdbn")}
        <tbody>
  {/* Search Row */}
  <tr>
    <td></td>
    <td>
      <input
        type="text"
        className="tetxinp"
        placeholder={t("Search Curriculum Name")}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
    </td>
    <td></td>
  </tr>

  {/* Curriculum Rows */}
  {curricu.curriculam?.map((item, index) => (
    <tr key={item.valu ?? index}>
      <td className="textcol">{index + 1}</td>

      <td className="textcol">
        {item.lab}
      </td>

      <td className="iconSec">
        <ReactTooltip effect="solid" />

        <div
          data-tip={t("View")}
          className="searchIc"
          onClick={() =>
            navi("/ViewSyllabus", { state: item.valu })
          }
        >
          <FaSearchPlus className="icons" style={{fontSize:"24px", padding:'6px'}} />
        </div>

        <div
          data-tip={t("Edit")}
          className="editBu"
          onClick={() =>
            navi("/UpdateSyllabus", { state: item.valu })
          }
        >
          <FaEdit className="icons" style={{fontSize:"24px", padding:'6px'}} />
        </div>
      </td>
    </tr>
  ))}
</tbody>


              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
